// ==============================|| OVERRIDES - TABLE HEAD ||============================== //

export default function TableHead(theme) {
  return {
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: theme.vars.palette.grey[50],
          '& .MuiTableCell-root': { backgroundColor: theme.vars.palette.grey[50] }
        }
      }
    }
  };
}
